import { isAxiosError } from 'axios';
import { t } from 'i18next';
import { showErrorToast } from '@/components/Toast';
import { ErrorIds } from '@/constants/ApiResponse';
import { apiErrorSchema } from '@/utils/error';

export const handleGlobalRequestError = (error: unknown) => {
  const result = apiErrorSchema.safeParse(error);

  if (result.success) {
    //error from our BE
    const backendError = result.data;
    if (
      (backendError.status === 500 && backendError.errorId === ErrorIds.INTERNAL_SERVER_ERROR) ||
      (backendError.status === 429 && backendError.errorId === ErrorIds.WAF_BLOCKED) //RateLimitExceeded error from WAF
    ) {
      showErrorToast(t('ErrorToast:defaultMessage'));
    }
  } else if (isAxiosError(error) && error.request.status >= 500) {
    //external service error other than our BE
    showErrorToast(t('ErrorToast:defaultMessage'));
  }
};
